import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import StatBadge from '../common/StatBadge';
import { useTravelGuide } from '../../context/TravelGuideContext';

const ComparePanel = ({ open, onClose }) => {
  const { comparedPlaceDetails, dispatch } = useTravelGuide();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Compare Places</DialogTitle>
      <DialogContent dividers>
        {comparedPlaceDetails.length === 0 ? (
          <Typography color="textSecondary">Select up to 3 places to compare.</Typography>
        ) : (
          <Grid container spacing={2}>
            {comparedPlaceDetails.map((place) => (
              <Grid key={place.id} item xs={12} md={4}>
                <Box border="1px solid #d0d5dd" borderRadius={12} p={2}>
                  <Typography variant="h6">{place.name}</Typography>
                  <Box mt={1} display="grid" gridGap={8}>
                    <StatBadge label="Rating" value={place.rating.toFixed(1)} />
                    <StatBadge label="Reviews" value={place.reviews} />
                    <StatBadge label="Price" value={place.priceLevel} />
                    <StatBadge label="Ranking" value={place.ranking} />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => dispatch({ type: 'CLEAR_COMPARE' })}
          color="secondary"
          disabled={comparedPlaceDetails.length === 0}
        >
          Clear
        </Button>
        <Button onClick={onClose} color="primary" variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ComparePanel;
